export const RECEIVED_FAVORITE_CONTACTS_INFINITE_LOADING = 'RECEIVED_FAVORITE_CONTACTS_INFINITE_LOADING'
export const RECEIVED_CONTACTS_INFINITE_LOADING = 'RECEIVED_CONTACTS_INFINITE_LOADING'
export const GET_FULLNAME = 'GET_FULLNAME'
export const SET_FULLNAME = 'SET_FULLNAME'
export const RECEIVED_FULLNAMES = 'RECEIVED_FULLNAMES'
export const GET_COMPANY = 'GET_COMPANY'
export const SET_COMPANY = 'SET_COMPANY'
export const RECEIVED_COMPANIES = 'RECEIVED_COMPANIES'
export const GET_POSITION = 'GET_POSITION'
export const SET_POSITION = 'SET_POSITION'
export const RECEIVED_POSITIONS = 'RECEIVED_POSITIONS'
export const POST_CONTACT_FAVORITE = 'POST_CONTACT_FAVORITE'



// WEBPACK FOOTER //
// ./src/store/modules/contact/mutation-types.js